import { useEffect, useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
import api from "@/lib/api";

const MONTHS_SHORT = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
const fmtTry = (v) => `₺${Number(v || 0).toLocaleString("tr-TR")}`;

function ChartTooltip({ active, payload }) {
    if (!active || !payload?.length) return null;
    return (
        <div className="rounded-xl border border-border bg-popover px-3 py-2 shadow-lg">
            <div className="text-[11px] text-muted-foreground mb-1">{payload[0]?.payload?.m}</div>
            {payload.map((p) => (
                <div key={p.dataKey} className="text-[12px] font-semibold">{fmtTry(p.value)}</div>
            ))}
        </div>
    );
}

export default function RevenueMiniChart({ variant = "income" }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        (async () => {
            try {
                const now = new Date();
                const year = now.getFullYear();
                const monthIdx = now.getMonth();
                const results = [];
                for (let i = 5; i >= 0; i--) {
                    const m = monthIdx - i;
                    const y = year + Math.floor(m / 12);
                    const mo = ((m % 12) + 12) % 12;
                    try {
                        const { data: r } = await api.get("/reports/monthly", { params: { year: y, month: mo + 1 } });
                        const t = r.total || {};
                        results.push({ m: MONTHS_SHORT[mo], income: t.revenue || 0, expense: t.expenses || 0, profit: (t.profit ?? ((t.revenue || 0) - (t.expenses || 0))) });
                    } catch { results.push({ m: MONTHS_SHORT[mo], income: 0, expense: 0, profit: 0 }); }
                }
                setData(results);
            } catch { setData([]); }
        })();
    }, []);
    const color = variant === "income" ? "hsl(var(--success))" : variant === "expense" ? "hsl(var(--destructive))" : "hsl(var(--brand))";
    const key = variant;
    return (
        <div className="h-16 -mx-2 mt-2">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={data} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
                    <defs>
                        <linearGradient id={`grad-${variant}`} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor={color} stopOpacity={0.35} />
                            <stop offset="100%" stopColor={color} stopOpacity={0.02} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid vertical={false} stroke="hsl(var(--border))" strokeOpacity={0.4} />
                    <XAxis dataKey="m" tick={{ fontSize: 9 }} axisLine={false} tickLine={false} />
                    <YAxis hide />
                    <Tooltip content={<ChartTooltip />} />
                    <Area type="monotone" dataKey={key} stroke={color} strokeWidth={1.6} fill={`url(#grad-${variant})`} />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}
